<template>
    <div class="layout4 agent-card" :class="agentDirection">
        <div class="avatar-info-wrap img-content">
            <a
                class="redrect"
                :href="redirectUrl"
                :target="detailUrlTarget"
                rel="noopener noreferrer"
            >
                <AgentHeadShot
                    class="avatar md-team-layout4"
                    :agent="agent"
                    :size="670"
                />
            </a>
        </div>
        <div
            class="agent-info-wrap"
            :style="{ background: agentBgColor }"
        >   
            <div class="inner" v-animated="textAnimation">
                <div class="full-name">
                    <span
                        class="agent-name"
                        v-if="agent.fullName"
                    >
                        {{ agent.fullName }}
                    </span>
                    <span class="position">
                        <span v-if="agent.position">{{ agent.position }}</span>
                        <span
                            class="split"
                            v-if="agent.license && agent.position"
                        >|</span>
                        <span v-if="agent.license">
                            {{ licenseName }} {{ agent.license }}
                        </span>
                    </span>
                </div>
                <div class="agent-introduction" v-if="agent.longIntroduction">
                    <div v-html="agent.longIntroduction" class="rich-text"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import agentInfo from '../agent-info';
import AgentHeadShot from '@/components/agent-headshot.vue'
export default {
    i18next: {
        ns: 'md-team'
    },
    props: {
        agent: {
            type: Object,
            required: true
        },
        licenseName: {
            type: String,
            default: ''
        },
        detailUrlTarget: {
            type: String,
            default: '_self'
        },
        showCalendarLink: {
            type: Boolean,
            default: true
        },
        agentBgColor: {
            type: String,
            default: ''
        },
        agentDirection: {
            type: String,
            default: 'right'
        },
        showAnimationEffects: {
            type: Boolean,
            default: true
        }
    },
    components: { AgentHeadShot },
    mixins: [agentInfo],
    computed: {
        textAnimation() {
            return {
                name: this.agentDirection == 'right' ? 'shift-right' : 'shift-left',
                enable: this.isMobileSize ? false : this.showAnimationEffects
            }
        }
    }
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
@import '../../../theme/mixin.scss';

.layout4.agent-card {
    display: flex;
    height: 345px;
    &.right {
        flex-direction: row-reverse;
    }
    &.left {
       flex-direction: row; 
    }

    .avatar-info-wrap {
        width: 260px;
        aspect-ratio: 3 / 4;
        overflow: hidden;
        a.redrect {
            display: block;
            height: 100%;
        }
        .avatar {
            width: 100%;
            height: 100%;
            object-fit: cover;
            vertical-align: middle;
            transition: transform 0.3s ease;
        }
        &:hover {
            cursor: pointer;
            .avatar {
                transform: scale(1.1);
            }
        }
    }
    .agent-info-wrap {
        flex: 1;
        .inner {
            width: 100%;
            height: 100%;
            padding: 40px 50px;
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            gap: 20px;
        }
        .full-name {
            .agent-name {
                display: inline-block;
                color: var(--g-primary-color);
                font-family: var(--mg-title-font);
                font-size: 34px;
                line-height: 1.5;
                text-align: left;
                word-break: break-word;
                margin-right: 20px;
                cursor: pointer;
            }
            .position {
                display: inline-block;
                color: var(--g-text-color);
                font-weight: 400;
                font-size: 16px;
                line-height: 1.5;
                text-align: left;
                word-break: break-word;
                margin-top: 10px;
                cursor: pointer;
            }
        }
        .agent-introduction {
            color: var(--g-primary-color);
            text-align: left;
            font-size: 18px;
            line-height: 1.5;
            font-weight: 400;
            position: relative;
            left: 0;
            width: calc(100% + 40px);
            overflow-y: auto;
            cursor: pointer;
            .rich-text {
                padding-right: 40px;
                max-height: 100%;
                font-weight: 400;
                word-break: break-word;
                overflow-y: auto;
                &::-webkit-scrollbar {
                    width: 6px;
                }
                &::-webkit-scrollbar-track {
                    background: transparent;
                    border-radius: 6px;
                }
                &::-webkit-scrollbar-thumb {
                    border-radius: 6px;
                    position: relative;
                    display: block;
                    width: 0;
                    height: 0;
                    cursor: pointer;
                    background-color: rgba(168, 168, 168, 1);
                    -webkit-transition: 0.3s background-color;
                    transition: 0.3s background-color;
                }
            }
        }
    }

    @include media-800 {
        display: block;
        width: 100%;
        height: 100%;

        .avatar-info-wrap {
            width: 100%;
            aspect-ratio: 335 / 445;
        }
        .agent-info-wrap {
            flex: none;
            width: 100%;
            .inner {
                padding: 20px;
            }
            .full-name {
                .agent-name {
                    font-size: 20px;
                    margin-right: 10px;
                }
                .position {
                    font-size: 14px;
                    margin-top: 5px;
                }
            }
            .agent-introduction {
                font-size: 14px;
                width: 100%;
                position: static;
                .rich-text {
                    padding-right: 0;
                }
            }
        }
    }
}
</style>
